let _ = require('../_.js');

var $ = jQuery;

/** 
 * This file is a variety of helper functions and behaviors for user interface effects which require jquery, mostly
 * related to html page layout, such as filling remaining available height. 
 */

_.ac_responsive_init = function () {

    // Adjusts the target element to a css style that makes it full height in its available height, minus the 
    // bottom padding, margin, and border of all parent elements.  The complexity is due to it not using getComputedStyle
    // for speed unless an anomoly is detected, then we fall back on the expensive function.
    // Adjust the minimum height of an element to fill to the bottom of the page without using getComputedStyle
    function adjustMinHeightVh_100(element) {
        element.style.boxSizing = 'border-box';
        let totalVerticalPaddingAndBorders = 0;
        let currentElement = element;

        totalVerticalPaddingAndBorders = 0

        // Iterate through all parent elements to manually add their known bottom padding, margins, and borders
        while (currentElement.parentElement && currentElement.tagName != 'body') {
            let parentPaddingBottom, parentMarginBottom, parentBorderBottomWidth;

            // Access inline styles first
            const inlineStyle = currentElement.parentElement.style;

            // Does this parseInt stuff work here?
            // Todo: replace with styleInt.
            parentPaddingBottom = inlineStyle.paddingBottom ? parseInt(inlineStyle.paddingBottom, 10) : null;
            parentMarginBottom = inlineStyle.marginBottom ? parseInt(inlineStyle.marginBottom, 10) : null;
            parentBorderBottomWidth = inlineStyle.borderBottomWidth ? parseInt(inlineStyle.borderBottomWidth, 10) : null;

            // If any of the styles are not defined inline, use getComputedStyle
            if (parentPaddingBottom === null || parentMarginBottom === null || parentBorderBottomWidth === null) {
                const style = window.getComputedStyle(currentElement.parentElement);
                parentPaddingBottom = parentPaddingBottom !== null ? parentPaddingBottom : parseInt(style.paddingBottom, 10);
                parentMarginBottom = parentMarginBottom !== null ? parentMarginBottom : parseInt(style.marginBottom, 10);
                parentBorderBottomWidth = parentBorderBottomWidth !== null ? parentBorderBottomWidth : parseInt(style.borderBottomWidth, 10);
            }

            if (currentElement == element) {
                parentMarginBottom = 0;
            }

            totalVerticalPaddingAndBorders += parentPaddingBottom + parentMarginBottom + parentBorderBottomWidth;
            currentElement = currentElement.parentElement;
        }

        // Set the minimum height based on the calculated total offsets
        element.style.minHeight = `calc(100vh - ${element.offsetTop}px - ${totalVerticalPaddingAndBorders}px)`;
        $(element).attr('data-found-margins', totalVerticalPaddingAndBorders);
    }


    // Handle fill-remaining-h - these elements grow in height to available height
    function adjustRemainingH(element, force = false) {
        let $element = $(element);
        if ($element.hasClass('fill-remaining-h')) {
            if (!$element.is(":visible")) return;

            // // Hmm...
            // $element.style('height', "-webkit-fill-available");
            // $element.style('max-height', "-webkit-fill-available");
            // return;

            // // Get the parent element
            let $parent = $element.parent();
            // let $first_parent = $parent;

            // if ($first_parent.css('overflow') == 'scroll' || $first_parent.css('overflow') == 'hidden' ||
            //     $first_parent.css('overflow-y') == 'scroll' || $first_parent.css('overflow-y') == 'hidden') {
            //     $first_parent.data('scrollTop', $first_parent[0].scrollTop);
            // }

            // // Set element to 0 height for calculations
            $element.style('height', '0px');
            $element.style('max-height', '0px');

            // // Get the left offset and the right offset of the current element
            var elementLeftOffset = $element.offset().left - $element.styleInt('marginLeft');
            var elementRightOffset = elementLeftOffset + $element.outerWidth();

            // // Calculate the height of all children that overlap with the target element excluding the target element
            var peerHeight = 0;
            var peerHeightNonFiltered = 0;

            let thisIndex = $element.index();

            $parent.children().not($element).each(function () {
                // Skip not visible elements
                if (!$(this).is(":visible")) return;
                if ($(this).index() < thisIndex) return;

                var childLeftOffset = $(this).offset().left - $(this).styleInt('marginLeft');
                var childRightOffset = childLeftOffset + $(this).outerWidth();

                // If there is an overlap of x-coordinates, they are vertically stacked
                if (childLeftOffset < elementRightOffset && childRightOffset > elementLeftOffset) {
                    peerHeight += $(this).outerHeight(true);
                }
                peerHeightNonFiltered += $(this).outerHeight(true);

            });

            // // Calculate the parent's height
            var parentHeight = $parent.height();

            // // Get the margin top and bottom
            var marginTop = $element.cssInt('marginTop');
            var marginBottom = $element.cssInt('marginBottom');

            var elementOffsetTop = $element.offset().top;
            var parentOffsetTop = $element.parent().offset().top;
            let offsetDif = elementOffsetTop - parentOffsetTop;

            // // Calculate the total height of all child elements within the target element
            var totalChildHeight = 0;
            $element.children().each(function () {
                if ($(this).css('overflow') == 'scroll' || $(this).css('overflow') == 'hidden' ||
                    $(this).css('overflow-y') == 'scroll' || $(this).css('overflow-y') == 'hidden') {
                    return;
                }
                if ($(this).is('table')) {
                    if ($(this).find('tbody').css('overflow') == 'scroll' || $(this).find('tbody').css('overflow') == 'hidden' ||
                        $(this).find('tbody').css('overflow-y') == 'scroll' || $(this).find('tbody').css('overflow-y') == 'hidden') {
                        return;
                    }
                }

                var marginTop = $(this).cssInt('marginTop');
                var marginBottom = $(this).cssInt('marginBottom');
                totalChildHeight += $(this).outerHeight() + marginTop + marginBottom;
            });

            // // Set the target element's height to the difference

            // This is the new height set to grow into the parents accomidating heights.
            var newHeight = parentHeight - marginTop - marginBottom - offsetDif - peerHeight; // - peerHeight totalChildHeight

            let overflow_prop = $element.css('overflow-y')
            let is_scrolling_element = overflow_prop === 'scroll' || overflow_prop === 'auto';

            // However, if the combined height of the children is larger than this, then we need to remove the height stylings on this element
            // and each of the parents that have fill-remaining-h.
            if (totalChildHeight < newHeight || is_scrolling_element) {
                $element.styleInt('min-height', newHeight);
                $element.styleInt('height', newHeight);
                // $element.style('color', 'blue');
                $element.style('max-height', '');
                if (is_scrolling_element && $element.css('display') == 'flex') {
                    if (totalChildHeight > newHeight) {
                        $element.css('justify-content', 'normal');
                        $element.styleInt('height', '');  // Testing - this fixes a glich when scroll begins
                        $element.styleInt('max-height', newHeight);
                    } else if ($element.style('justify-content') == 'normal') {
                        $element.css('justify-content', '');
                    }
                }
            } else {
                let $operating_node = $element;
                while ($operating_node !== null) {
                    $operating_node.style('min-height', '');
                    $operating_node.style('height', '');
                    $operating_node.style('max-height', '');
                    let $parent = $operating_node.parent();
                    if ($parent && $parent.length && $parent.prop('tagname') != 'BODY' && $parent.hasClass('fill-remaining-h')) {
                        $operating_node = $parent;
                    } else {
                        $operating_node = null;
                    }
                }
            }

            // if ($element.hasClass('clerk-ui-top-container-2')) {
            if ($element.hasClass('align-item-center-center') && $element.hasClass('modal-body')) {
                // console.warn(newHeight);
            }
            if ($element.hasClass('clerk-ui-top-container-size-helper')) {
                // console.warn(newHeight);
            }

            // if ($first_parent.css('overflow') == 'scroll' || $first_parent.css('overflow') == 'hidden' ||
            //     $first_parent.css('overflow-y') == 'scroll' || $first_parent.css('overflow-y') == 'hidden') {
            //     $first_parent[0].scrollTop = $first_parent.data('scrollTop');
            // }

            // $element.attr('data-pheight', parentHeight);
            // $element.attr('data-pcheight', peerHeight);
            // $element.attr('data-cheight2', totalChildHeight);
        }
    }

    // Handle table-scrollable-element - these tables grow in height to available height
    function adjustTableRemainingH(element, force = false) {
        let $element = $(element);
        if ($element.hasClass('table-scrollable-element')) {
            $element.parent().css('overflow-y', 'scroll');
            // // if (!$element.style("display") == 'none') return;

            // // Get the parent element
            // var $parent = $element.parent();

            // // Set tbody height to 0px for calculations
            // var $tbody = $element.children('tbody');
            // $tbody.style('height', '0px');

            // // Get the offset of the current element
            // var elementLeftOffset = $element.offset().left - $element.styleInt('marginLeft');
            // var elementRightOffset = elementLeftOffset + $element.outerWidth();

            // // Calculate the height of all children that overlap with the target element excluding the target element and the table
            // var childrenHeight = 0;
            // $parent.children().not($element).each(function () {
            //     // Skip not visible elements
            //     // if (!$(this).is(":visible")) return;

            //     var childLeftOffset = $(this).offset().left - $(this).styleInt('marginLeft');
            //     var childRightOffset = childLeftOffset + $(this).outerWidth();

            //     // If there is an overlap of x-coordinates, they are vertically stacked
            //     if (childLeftOffset < elementRightOffset - 1 && childRightOffset > elementLeftOffset + 1) {
            //         childrenHeight += $(this).outerHeight(true);
            //     }
            // });

            // // Calculate the parent's height
            // var parentHeight = $parent.height();

            // // Get the margin top and bottom
            // var marginTop = $element.cssInt('marginTop');
            // var marginBottom = $element.cssInt('marginBottom');

            // // Consider the height of the thead
            // var theadHeight = $element.find('thead').outerHeight(true);

            // if (!theadHeight) {
            //     theadHeight = 0;
            // }

            // // Set the tbody's height to the difference
            // var newHeight = parentHeight - childrenHeight - marginTop - marginBottom - theadHeight;

            // console.log("NH", parentHeight, childrenHeight, marginTop, marginBottom, theadHeight);
            // console.log("NH2", newHeight);

            // if (newHeight < 0) {
            //     // console.warn("The combined children's height and the thead's height is greater than the parent's height. Setting the tbody's height to 0.");
            //     newHeight = 0;
            // }

            // // Set the height and display the tbody a
            // if (newHeight != 0) {
            //     newHeight = '';
            // }

            // $tbody.styleInt('height', newHeight);

            // $element.attr('data-pheight', parentHeight);
            // $element.attr('data-pcheight', childrenHeight);
        }
    }

    function centerElementVertically(element) {
        var $element = $(element);
        if ($element.hasClass('vertical-center')) {
            var $firstChild = $element.children().first();
            $firstChild.style("margin-top", '');

            var parentHeight = $element.height();
            var childrenHeight = 0;
            $element.children().each(function () {
                childrenHeight += $(this).outerHeight(true);
            });

            var marginTop = (parentHeight - childrenHeight) / 2;
            if (marginTop > 0) {
                $firstChild.style("margin-top", marginTop);
            }
        }
    }

    // Reset styles
    _.ac_responsive_clearHeights = function () {
        $('.fill-remaining-h, .fill-100-vh').style({
            'height': '',
            'min-height': '',
            'max-height': ''
        });

        $(".fill-remaining-h").style({ 'height': '0px' });
        // $(".table-scrollable-element tbody").style({ 'height': '0px' });
        $(".vertical-center").style({ 'margin-top': '0px' });
    };

    let all_scrollable_elements = '.fill-100-vh, .fill-100-min, .fill-remaining-h, .table-scrollable-element';

    // Apply styles
    _.ac_responsive_adjustHeights = function () {
        $(".lp-modal").each(function () {
            let $that = $(this);
            if ($that.is(":visible")) {
                $that.data('scroll', $that.scrollTop());
            } else {
                $that.data('scroll', 0);
                $that.scrollTop(0);
            }
        });

        // Save scroll position
        $(all_scrollable_elements).each(function () {
            $(this).data('real-scroll-height', this.scrollTop);
        });

        // Reset all heights to zero for calculations
        _.ac_responsive_clearHeights();

        // function sortByDepth(elements) {
        //     return elements.sort(function (a, b) {
        //         let depthA = 0, elA = a;
        //         while (elA) {
        //             depthA++;
        //             elA = elA.parentNode;
        //         }

        //         let depthB = 0, elB = b;
        //         while (elB) {
        //             depthB++;
        //             elB = elB.parentNode;
        //         }

        //         return depthA - depthB;
        //     });
        // }

        // Collect all elements
        let allElements = $('.fill-100-vh, .fill-100-min, .fill-remaining-h, .table-scrollable-element, .vertical-center');

        // Sort elements by depth
        // let sortedElements = sortByDepth(allElements.toArray());

        // Now iterate over sorted elements and apply adjustments based on their class
        $(allElements).sortElements().each(function () {
            if ($(this).is('.table-scrollable-element')) adjustTableRemainingH(this);
            if ($(this).is('.fill-100-vh, .fill-100-min')) adjustMinHeightVh_100(this);
            if ($(this).is('.fill-remaining-h')) adjustRemainingH(this);
            if ($(this).is('.vertical-center')) centerElementVertically(this);
        });

        // console.log("Updated element heights");

        // Restore scroll
        $(all_scrollable_elements).each(function () {
            const $element = $(this);
            if ($(this).data('real-scroll-height')) {
                this.scrollTop = $(this).data('real-scroll-height');
            }
        });

        $(".lp-modal").each(function () {
            let $that = $(this);
            $that.scrollTop($that.data('scroll'));
        });
    };

    // Run again on window resize
    _.on_ui_resize(_.ac_responsive_adjustHeights);

    // Apply $().autoheight to children of class autoheight
    _.on_ui_update_once(".autoheight", function () {
        $(this).children().autoheight();
    });

    // Track scrolling of all elements for restore on redraw
    _.on_ui_update_once(all_scrollable_elements, function () {
        $(this).on('scroll', function () {
            // console.log("set", this.scrollTop);
            $(this).data('real-scroll-height', this.scrollTop);
        });
    });
}

// This is a super gross fix and the real issue should be found and fixed.
// comment this out and close/ repoen a modal a few times to see what i mean.
setInterval(function () {
    $(".fill-remaining-h:visible").each(function () {
        if ($(this).style('height')) {
            let height = $(this).style('height').replace("px", "");
            if (height < 5) {
                $(this).style('height', '');
            }
        }
    });
}, 150);


// Jquery plugin 'autoheight'
// This code will target multiple div tags with flexible heights based on their content. When called, and on the browser 
// window resize event, it first removes the height from every element, lets an animation frame happen, and then adjusts 
// the height for every row of elements.
$.fn.autoheight = function () {

    var all_elements = [];
    this.each(function () {
        if ($(this).parents(".no-match-height").length == 0) {
            all_elements.push($(this));
        }
    });

    _.on_ui_resize(function () {
        // Function to handle auto height adjustment

        // Filter by visible
        let elements = [];
        all_elements.forEach(function ($e) {
            if ($e.is(":visible")) {
                elements.push($e);
            }
        });

        // Reset the min-height of the element
        elements.forEach(function ($element) {
            var minHeight = $element.style('min-height');

            if (minHeight && minHeight != '0px') {
                // Element has a min-height, so store it
                $element.data('true-min-height', minHeight);
            } else if (!$element.data('true-min-height')) {
                // Element doesn't have a min-height, and hasn't been processed before
                $element.data('true-min-height', 'false');
            }

            // Reset min-height for subsequent processing
            if ($element.data('true-min-height') == 'false') {
                $element.style('min-height', '');
            } else {
                $element.style('min-height', $element.data('true-min-height'));
                // setTimeout(function () {
                // $element.style('max-height', $element.data('true-min-height'));
                // }, 0);
            }
        });


        var single_row = [];
        var prevX = null;

        var adjust_this_row_height = function () {
            return new Promise((resolve, reject) => {
                var max_height = 0;
                if (single_row.length <= 1) {
                    resolve();
                }
                single_row.forEach(function ($element) {
                    max_height = Math.max(max_height, $element.outerHeight());
                });
                single_row.forEach(function ($element) {
                    // console.log($element.style('height'));
                    $element.styleInt('min-height', max_height);
                });
                // Let boxes shift positions after new row height is set
                // requestAnimationFrame(function () {
                // console.log('r2');
                resolve();
                // });
            });
        }

        var adjust_all_heights = async function () {
            for (let $element of elements) {
                var elementX = $element.offset().left;

                // If it's the first element, or the X position is greater than the previous element
                if (prevX == null || elementX > prevX) {
                    single_row.push($element);
                } else {
                    await adjust_this_row_height();
                    single_row = [];
                    single_row.push($element);
                    elementX = $element.offset().left;
                }

                prevX = elementX;
            }

            adjust_this_row_height();
        };

        adjust_all_heights();
    });
};
